(() => {
  const PARAMS = {
    journeyId: "wd_journey_id",
    leadId: "wd_lead_id",
  };
  const SESSION_KEY = "water_doctor_shop_attribution_v1";
  const CART_SYNC_KEY = "water_doctor_shop_cart_attribution_v1";
  const ID_PATTERN = /^[A-Za-z0-9_.:~-]+$/;
  const MAX_ID_LENGTH = 128;

  const readSession = (key) => {
    try {
      return window.sessionStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  };

  const writeSession = (key, value) => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (_error) {
      // Attribution must never interrupt browsing or checkout.
    }
  };

  const normalizeId = (value) => {
    if (typeof value !== "string") return "";

    const normalized = value.trim();
    if (
      normalized.length === 0 ||
      normalized.length > MAX_ID_LENGTH ||
      !ID_PATTERN.test(normalized)
    ) {
      return "";
    }

    return normalized;
  };

  const readStoredIdentity = () => {
    const stored = readSession(SESSION_KEY);
    if (!stored) return {};

    try {
      const parsed = JSON.parse(stored);
      return {
        journeyId: normalizeId(parsed.journeyId),
        leadId: normalizeId(parsed.leadId),
      };
    } catch (_error) {
      return {};
    }
  };

  const searchParams = new URLSearchParams(window.location.search);
  const incomingIdentity = {
    journeyId: normalizeId(searchParams.get(PARAMS.journeyId)),
    leadId: normalizeId(searchParams.get(PARAMS.leadId)),
  };
  const storedIdentity = readStoredIdentity();
  const identity = {
    journeyId: incomingIdentity.journeyId || storedIdentity.journeyId || "",
    leadId: incomingIdentity.leadId || storedIdentity.leadId || "",
  };

  if (identity.journeyId || identity.leadId) {
    writeSession(SESSION_KEY, JSON.stringify(identity));
  }

  const syncCartAttributes = async () => {
    if (!identity.journeyId && !identity.leadId) return;

    const attributes = {
      wd_handoff_source: "official_to_shop",
    };
    if (identity.journeyId) attributes.wd_journey_id = identity.journeyId;
    if (identity.leadId) attributes.wd_lead_id = identity.leadId;

    const signature = JSON.stringify(attributes);
    if (readSession(CART_SYNC_KEY) === signature) return;

    const root = window.Shopify?.routes?.root || "/";
    try {
      const response = await window.fetch(`${root}cart/update.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ attributes }),
      });

      if (response.ok) {
        writeSession(CART_SYNC_KEY, signature);
      }
    } catch (_error) {
      // A temporary attribution failure must not block the storefront.
    }
  };

  const isOfficialSiteUrl = (url) =>
    url.protocol === "https:" &&
    (url.hostname === "waterdoctor.ca" || url.hostname === "www.waterdoctor.ca");

  const enrichOfficialLink = (link) => {
    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_error) {
      return null;
    }

    if (!isOfficialSiteUrl(url)) return null;

    if (identity.journeyId) url.searchParams.set(PARAMS.journeyId, identity.journeyId);
    if (identity.leadId) url.searchParams.set(PARAMS.leadId, identity.leadId);
    link.href = url.toString();
    return url;
  };

  const enrichOfficialLinks = () => {
    document.querySelectorAll('a[href*="waterdoctor.ca"]').forEach(enrichOfficialLink);
  };

  const recordOfficialHandoff = (link) => {
    // Links added later by cart/section rendering are enriched at click time too.
    const url = enrichOfficialLink(link);
    if (!url) return;

    const detail = {
      destination_path: url.pathname,
      placement: url.searchParams.get("wd_placement") || "unspecified",
      has_journey_id: Boolean(identity.journeyId),
      has_lead_id: Boolean(identity.leadId),
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "shop_to_official_handoff", ...detail });
    document.dispatchEvent(
      new CustomEvent("waterdoctor:shop-to-official-handoff", { detail }),
    );
  };

  const initialize = () => {
    enrichOfficialLinks();
    void syncCartAttributes();

    document.addEventListener("click", (event) => {
      const link = event.target.closest?.("a[href]");
      if (link) recordOfficialHandoff(link);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
